import React from "react";
import { Navigate } from "react-router-dom";

// Utility to get cookie value
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

const ProtectedRoute = ({ children }) => {
  const accessToken = getCookie("access_token");
  return accessToken ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
